import Subtitle from "../Subtitle/Subtitle";
import styled from "styled-components";
import { StopwatchOutline } from "../../assets/icons";
import DateHelper from "../../helpers/DateHelper";
import { useTranslation } from "react-i18next";
import { MessageStyles } from "../../types";

const SpacedSubtitlesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const MessageLabel = styled.div`
  font-weight: 500;
`;

export type ReturnTableNoticeProps = {
  styles?: MessageStyles;
  leaveTime: string;
  isPromotion?: boolean;
};

export const ReturnTableNotice: React.FC<ReturnTableNoticeProps> = ({
  styles,
  leaveTime,
  isPromotion = false,
}) => {
  const { t } = useTranslation();

  return (
    <SpacedSubtitlesContainer>
      <Subtitle icon={StopwatchOutline} styles={styles}>
        <MessageLabel
          data-id={
            isPromotion
              ? "promotion-table-return-message"
              : "table-return-message"
          }
        >
          {t(isPromotion ? "PromotionTableReturn" : "AvailableUntil")}{" "}
          {DateHelper.formatAvailableUntilDisplayTime(leaveTime)}
        </MessageLabel>
      </Subtitle>
    </SpacedSubtitlesContainer>
  );
};

export default ReturnTableNotice;
